import { List, ListSubHeader } from '@pocketlaw/tetris';
export function Section(props) {
    const { title, children } = props;
    return (<List $density="large">
      <ListSubHeader>{title}</ListSubHeader>
      {children}
    </List>);
}
